import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import DesignSystemDialog from "../dialog-components/DesignSystemDialog";
import { useTranslation } from "react-i18next";
import CelebrationIcon from "@mui/icons-material/Celebration";

export default function WelcomeDialog({ open, onClose, onGetStarted }) {
	const { t } = useTranslation();

	const handleGetStarted = () => {
		if (onGetStarted) {
			onGetStarted();
		}
		onClose();
	};

	return (
		<DesignSystemDialog
			open={open}
			onClose={onClose}
			title={t("welcome-dialog-title")}
			icon={<CelebrationIcon />}
			maxWidth="md"
			actions={
				<>
					<Button variant="contained" color="primary" onClick={handleGetStarted}>
						{t("welcome-dialog-get-started")}
					</Button>
				</>
			}
		>
			<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
				<Typography variant="body1" sx={{ fontSize: "1.1rem", lineHeight: 1.6 }}>
					{t("welcome-dialog-message")}
				</Typography>
				<Typography variant="body1" sx={{ fontSize: "1.1rem", lineHeight: 1.6 }}>
					{t("welcome-dialog-animals")}
				</Typography>
			</Box>
		</DesignSystemDialog>
	);
}

